import React from 'react';
import Grid from '@mui/material/Grid';
import { GridSection, GridLeft, GridRight } from '../../../Episode.Styled';
import {
  CalOMSAdmitSubHeading,
  CheckboxGridItems,
  CheckboxGridItemsWithField,
  InputFieldGridItems,
} from '../AuthTabCommonUtils';
import {
  alcoholUsedDays,
  arrestedDays,
  criminalJusticeStatus,
  departmentCorrection,
  drugUsedDays,
  employementStatus,
  firstTimeDrugUsage,
  getYesNo,
  routeOfAdministration,
  secondaryAlcoholProblem,
} from '../authTabConstants';
import {
  adu5a,
  adu5b,
  adu6,
  adu7,
  adu8,
  adu9,
  adu10,
  adu11,
  emp1,
  emp2,
  emp3,
  emp4,
  emp5,
  leg1,
  leg2,
  leg3,
  leg4,
  leg5,
  leg6,
  leg7,
} from './CalOMSQuestionnaireConstants';

const PageThreeCalOMS = () => {
  return (
    <Grid container>
      <GridSection mx={2} item container spacing={1}>
        <GridLeft item container xs={6}>
          <CalOMSAdmitSubHeading title="Alcohol and Other Drug Use (continued)" />

          <CheckboxGridItems
            heading="ADU-5A"
            data={secondaryAlcoholProblem}
            text={adu5a}
          />

          <InputFieldGridItems heading="ADU-5B" value="" text={adu5b} />

          <CheckboxGridItems heading="ADU-6" data={drugUsedDays} text={adu6} />

          <CheckboxGridItems
            heading="ADU-7"
            data={routeOfAdministration}
            text={adu7}
          />

          <CheckboxGridItems
            heading="ADU-8"
            data={firstTimeDrugUsage}
            text={adu8}
          />

          <CheckboxGridItems
            heading="ADU-9"
            data={alcoholUsedDays}
            text={adu9}
          />

          <CheckboxGridItems
            heading="ADU-10"
            data={drugUsedDays}
            text={adu10}
          />

          <CheckboxGridItems heading="ADU-11" data={getYesNo} text={adu11} />
        </GridLeft>

        <GridRight item container xs={6}>
          <CalOMSAdmitSubHeading title="Employement Education" />

          <CheckboxGridItems
            heading="EMP-1"
            data={employementStatus}
            text={emp1}
          />

          <CheckboxGridItems heading="EMP-2" data={drugUsedDays} text={emp2} />

          <CheckboxGridItems heading="EMP-3" data={getYesNo} text={emp3} />

          <CheckboxGridItems heading="EMP-4" data={getYesNo} text={emp4} />

          <CheckboxGridItems heading="EMP-5" data={drugUsedDays} text={emp5} />

          <CalOMSAdmitSubHeading title="Legal / Criminal Justice" />

          <CheckboxGridItems
            heading="LEG-1"
            data={criminalJusticeStatus}
            text={leg1}
          />

          <CheckboxGridItemsWithField
            heading="LEG-2"
            data={departmentCorrection}
            text={leg2}
            value="VV83658"
          />

          <CheckboxGridItems heading="LEG-3" data={arrestedDays} text={leg3} />

          <CheckboxGridItems heading="LEG-4" data={drugUsedDays} text={leg4} />

          <CheckboxGridItems heading="LEG-5" data={drugUsedDays} text={leg5} />

          <CheckboxGridItems heading="LEG-6" data={getYesNo} text={leg6} />

          <CheckboxGridItems heading="LEG-7" data={getYesNo} text={leg7} />
        </GridRight>
      </GridSection>
    </Grid>
  );
};

export default PageThreeCalOMS;
